export default "__VITE_ASSET__CtMc$M2n__"